import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';
import { DASHBOARD } from '../../utils/constant';

const Dashboard = Loadable(lazy(() => import('./Dashboard')));

const dashboardRoutes = [
  { path: '/dashboard/default', element: <Dashboard />, auth: authRoles.guest, permission: DASHBOARD },
];

export default dashboardRoutes;
